
<script setup>
    import { computed, reactive, onMounted, watch } from 'vue'
    import { onAuthStateChanged, signOut } from "firebase/auth";
    import { useRouter } from 'vue-router'
    import { ref as databaseRef, onValue, update, push, child, set, get } from "firebase/database";
    import { formatToTimeZone } from 'date-fns-timezone';
    import { useRoute } from 'vue-router'
    import HeaderComponent from "../../components/common/HeaderComponent.vue"
    import EditTerminalComponent from "../../components/business/EditTerminalComponent.vue"
    import AddTerminalComponent from "../../components/business/AddTerminalComponent.vue"
    import NavigationBar from "../../components/business/NavigationBar.vue"
    import DefaultModalComponent from '../../components/common/DefaultModalComponent.vue'
    import LockStatusComponent from '../../components/business/LockStatusComponent.vue'
    import PaginateComponent from 'vuejs-paginate-next'
    import Firebase from "../../firebase_settings/index.js"
    import utilFunctions from "../../firebase_settings/utils.js"
    import Error from "../../firebase_settings/error.js"

    const FORMAT = 'YYYY/MM/DD HH:mm:ss';
    const TIME_ZONE_TOKYO = 'Asia/Tokyo';
    const auth = Firebase.auth
    const database = Firebase.database;
    const router = useRouter()
    const route = useRoute()

    //端末情報等のリアクティブオブジェクト
    const reactiveObj = reactive({
        //企業ID
        corporateId: "",
        //ドア情報一覧
        terminalObjects: [],
        //子コンポーネントに渡すようのドア情報
        terminalObject: {},
        //再レンダリング用のキー
        renderKey: 0,
        //現在のページ（デフォルトは１ページ）
        currentPage: 1,
        //端末追加用のモーダル
        addModalFlag: false,
        //端末編集用モーダル
        editModalFlag: false,
        //端末削除用モーダル
        deleteModalFlag: false,
        //単体施錠用モーダル
        lockModalFlag: false,
        //削除用モーダルメッセージ
        modalMessage: "",
        //削除用モーダルメッセージ(赤字)
        modalRedMessage: "",
        //主に削除用に使用
        otherObject: {},
        //単体施錠判別フラグ
        CompletelyLock: false,
        //夜間施錠判別フラグ
        NightFlag: false,
        //現在時刻
        CurrentTime: Date.now(),
        loadingFlag: false,
    })
    //1ページに表示する件数
    const perPage = 10;
    //firebaseからログイン利用者の情報を取得
    const getTerminals = async() => {
        const terminalsRef = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/Terminals`)
        //firebaseからドア情報を取得する
        onValue(terminalsRef, (snapshot) => {
            reactiveObj.terminalObjects = []
            const terminals = (snapshot.val())
            for (let key in terminals) {
                reactiveObj.terminalObjects.push({
                    'terminalId': key,
                    'TerminalName': terminals[key]['TerminalName'],
                    'Location': terminals[key]['Location'],
                    'LockTime': terminals[key]['LockTime'],
                    'TerminalType': terminals[key]['TerminalType'],
                    'TerminalPair': terminals[key]['TerminalPair'],
                    'Connection': terminals[key]['Connection'],
                    'DeviceType': terminals[key]['DeviceType'],
                    'DisplayLatestUpdated': terminals[key]["DisplayLatestUpdated"] ? formatToTimeZone(terminals[key]["DisplayLatestUpdated"], FORMAT, { timeZone: TIME_ZONE_TOKYO }) : "",
                    'EntryExit': terminals[key]['EntryExit'],
                    'LatestUpdated': formatToTimeZone(terminals[key]["LatestUpdated"], FORMAT, { timeZone: TIME_ZONE_TOKYO }),
                    'CompletelyLock': terminals[key]['CompletelyLock'],
                    'RemoteInput': terminals[key]['RemoteInput'],
                    'AllowViewAccount':  terminals[key]['AllowViewAccount'],
                })
            }
        })
        reactiveObj.renderKey++
    }
    //n個目のモーダルを表示する
    const showEditModal = (data, key) => {
        reactiveObj.editModalFlag = true
        reactiveObj.terminalObject = data
    }
    //モーダルを閉じる
    const closeEditModal = async (editFlag, editTerminalObject) => {
        //n個目のモーダルを閉じる
        reactiveObj.editModalFlag = false
        //更新対象の判別
        if(editFlag) {
            //入力が単独かつ既存の設定の値に親子設定がされている場合
            if(editTerminalObject['editTerminalInfo']['TerminalType'] == 'single' && reactiveObj.terminalObject['TerminalPair']){
                alert(Error.errorResult({ code: 'TSE0001'}, route.name))
                return
            }
            //入力が親機/子機かつ親子設定がされていない場合
            else if(editTerminalObject['editTerminalInfo']['TerminalType'] != 'single' && !reactiveObj.terminalObject['TerminalPair']){
                alert(Error.errorResult({ code: 'TSE0002'}, route.name))
                return
            }
            //上記以外
            else {
                const terminalData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/Terminals/${editTerminalObject['terminalId']}`);
                //入力された値に更新
                await update(terminalData, editTerminalObject['editTerminalInfo']);
                //接続設定が接続解除の場合、顔画像の登録状況を1(登録済)に変更する(1にしないと、アプリ側で顔画像を取得しにいけないため)
                if(!editTerminalObject['editTerminalInfo']['Connection']){
                    await changeFaceStatus(editTerminalObject['terminalId'])
                }
                if(editTerminalObject['editTerminalInfo']['TerminalType'] != 'single') {
                    //更新された端末の設定内容に応じて値を設定する
                    const editTerminalPairInfo = {
                        'TerminalName': editTerminalObject['editTerminalInfo']['TerminalName'],
                        'Location': editTerminalObject['editTerminalInfo']['Location'] == '外側' ? '内側' : '外側',
                        'LockTime': editTerminalObject['editTerminalInfo']['LockTime'],
                        'TerminalType': editTerminalObject['editTerminalInfo']['TerminalType'] == 'parent' ? 'child' : 'parent',
                        'EntryExit': editTerminalObject['editTerminalInfo']['EntryExit'] == '入室' ? '退室' : '入室',
                        'LatestUpdated': editTerminalObject['editTerminalInfo']['LatestUpdated']
                    }
                    //更新された端末の対となる端末を更新する
                    const terminaPairlData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/Terminals/${reactiveObj.terminalObject.TerminalPair}`);
                    await update(terminaPairlData, editTerminalPairInfo);
                }
            }
        }
        reactiveObj.terminalObject = {}
    }
    //端末追加のモーダルウィンドウを開く際に実行
    const showAddModal = () => {
        //モーダルウィンドウを開く
        reactiveObj.addModalFlag= true
    }
    //端末追加のモーダルウィンドウを閉じる際に実行
    const closeAddModal = (editFlag, newTeminalObj) => {
        //モーダルウィンドウを閉じる
        reactiveObj.addModalFlag= false
        if(editFlag){
            const locationMap = {
                "内側": "退室",
                "外側": "入室"
            }
            let parentId = ""
            let childId = ""
            const terminalPath = `CorporateId/${reactiveObj.corporateId}/Terminals`
            //追加する際に親を選択した場合には自動的に子機も作成するようにする(1回目：親機or単独の作成、2回目：子機の作成)
            for(let i = 0; i < (newTeminalObj.TerminalType == 'parent' ? 2 : 1); i++){
                const newTeminalKey = push(child(databaseRef(database), terminalPath)).key;
                    i == 0 ? parentId = newTeminalKey : childId = newTeminalKey
                    const data = {
                        "AllowViewAccount": [auth.lastNotifiedUid],
                        "Connection": false,
                        "DeviceType": "Sesame",
                        "LatestUpdated": Date.now(),
                        "DisplayLatestUpdated": 0,
                        "Location": i == 0 ? newTeminalObj.Location :
                            newTeminalObj.Location == "内側" ? "外側" : "内側",
                        "LockTime": Number(newTeminalObj.LockTime),
                        "PermittedGroupId": [
                            "All"
                        ],
                    "Entry": "入室",
                    "Exit": "退室",
                    "TerminalName": newTeminalObj.TerminalName,
                    "TerminalType": i == 0 ? newTeminalObj.TerminalType : 'child',
                    "EntryExit": i == 0 ? locationMap[newTeminalObj.Location] :
                        locationMap[newTeminalObj.Location == "内側" ? "外側" : "内側"],
                    'CompletelyLock': false,
                    'RemoteInput': ''
                }
                //端末を追加
                update(databaseRef(database, `${terminalPath}/${newTeminalKey}`), data)
                //顔画像情報の登録状況を更新
                //(顔画像は端末情報ごとに管理されているため)
                console.log('setFaceStatus')
                setFaceStatus(newTeminalKey)
                
            }
            //親子関係の設定
            update(databaseRef(database, `${terminalPath}/${parentId}`), {"TerminalPair": childId})
            if(childId) {
                update(databaseRef(database, `${terminalPath}/${childId}`), {"TerminalPair": parentId})
            }
            countTerminal()
        }
    }
    //端末削除のモーダルウィンドウを開く際に実行
    const showDeleteModal = (data, key) => {
        //子コンポーネントに渡すオブジェクト
        reactiveObj.otherObject = {
            terminalIndex: key,
            confirm: '削除する',
            modalWidth: "35%",
        }
        //モーダルウィンドウを開く
        reactiveObj.deleteModalFlag = true
        //削除対象が親機か子機（単独）に応じてメッセージを変更する
        let TerminalType = data.TerminalType == 'parent'? '親機': data.TerminalType == 'child'? '子機' : '単独'
        //モーダルウィンドウに表示するメッセージを設定　※ここでHTMLの設定しないと反映できない
        reactiveObj.modalMessage = `以下の端末を削除します。<br>よろしいですか？<br><br>端末名：${data.TerminalName}<br>設置先：${data.Location}<br>親子設定：${TerminalType}`
        reactiveObj.modalRedMessage = data.TerminalType == 'parent' ? "※親機を削除すると、子機も同時に削除されます。" : ""
        //モーダルウィンドウを再描画
        reactiveObj.renderKey++
    }
    //端末削除のモーダルウィンドウを閉じる際に実行
    const closeDeleteModal = async (deleteFlag) => {
        //削除対象の番号
        const terminalIndex = reactiveObj.otherObject.terminalIndex
        //端末ID(顔画像登録状態削除用)
        let terminalKeys = []
        //モーダルウィンドウを閉じる
        reactiveObj.deleteModalFlag = false
        //削除に同意しているか
        if(deleteFlag) {
            reactiveObj.loadingFlag = true
            //端末IDを取得
            terminalKeys.push(reactiveObj.terminalObjects[terminalIndex]['terminalId'])
            const terminalData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/Terminals/${reactiveObj.terminalObjects[terminalIndex]['terminalId']}`);
            const terminalPairlData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/Terminals/${reactiveObj.terminalObjects[terminalIndex]['TerminalPair']}`);
            //親子設定の状態に分けて処理を行う
            switch (reactiveObj.terminalObjects[terminalIndex]['TerminalType']) {
                //親機を削除する場合
                case 'parent':
                    //対となる端末（子機）が存在しているなら（子機を）削除する
                    if(reactiveObj.terminalObjects[terminalIndex]['TerminalPair']) {
                        //子機の端末IDも追加
                        terminalKeys.push(reactiveObj.terminalObjects[terminalIndex]['TerminalPair'])
                        await set(terminalPairlData, {})
                    }
                    break
                //子機を削除する場合
                case 'child':
                    //対となる端末（親機）が存在しているなら（親機の）親子関係を解除し、単独に変更する
                    if(reactiveObj.terminalObjects[terminalIndex]['TerminalPair']) {
                        await update(terminalPairlData, {
                            "TerminalPair": "",
                            "TerminalType": "single"
                        })
                    }
                    break
                //単独を削除する場合
                case 'single':
                    //何もしない
                    break
            }
            //端末を削除
            await set(terminalData, {})
            //顔画像登録状態を削除
            await deleteFaceStatus(terminalKeys)
            countTerminal()
            //削除後にページ数が減った場合の調整
            adjustPagecount()
            reactiveObj.loadingFlag = false
        }
        //子コンポーネントに渡すオブジェクトをリセット
        reactiveObj.otherObject = {}
    }
    //端末追加のモーダルウィンドウを開く際に実行
    const showStatusModal = (data, key) => {
        //モーダルウィンドウを開く
        reactiveObj.lockModalFlag = true
        reactiveObj.terminalObject = data
    }
    const closeStatusModal = async (modeFlag, move) => {
        reactiveObj.lockModalFlag = false
        if(modeFlag) {
            const terminalData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/Terminals/${reactiveObj.terminalObject.terminalId}`);
            await update(terminalData, {RemoteInput: move});
        }
        reactiveObj.terminalObject = {}
    }
    //ページネーションを押下した時
    const clickCallback = (pageNum) => {
        reactiveObj.currentPage = Number(pageNum);
    }
    //Nページ目に表示するドア情報を取得
    const getItems = computed(() => {
        let current = reactiveObj.currentPage * perPage;
        let start = current - perPage;
        return reactiveObj.terminalObjects.slice(start, current);
    })
    //現在のページ数を取得
    const getPageCount = computed(() => {
        return Math.ceil(reactiveObj.terminalObjects.length / perPage) ? Math.ceil(reactiveObj.terminalObjects.length / perPage) : 1
    })
    //夜間施錠判定
    const isWithinTimeRange = (start, end, current) => {
        return start <= end
            ? current >= start && current < end
            : current >= start || current < end;
    };
    //アプリ設定情報の取得（リアルタイム更新）
    const getAppSetting = async () => {
        const settingsRef = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/AppSettings`)
            //firebaseからアプリ情報を取得する
            await onValue(settingsRef, (snapshot) => {
                const settings = (snapshot.val())
                const NightStart = settings["NightStart"]
                const NightEnd = settings["NightEnd"]
                reactiveObj.currentTime = new Date().getHours() * 100 + new Date().getMinutes()
                reactiveObj.NightFlag = settings["NightFlag"] && isWithinTimeRange(NightStart, NightEnd, reactiveObj.currentTime)
            })
    }
    //顔画像登録状態の設定
    const setFaceStatus = async(terminalUUId) => {
        const userPath = `CorporateId/${reactiveObj.corporateId}/User`
        const getUserRef = databaseRef(database, userPath);
        // 更新用オブジェクトの作成
        const updates = {};
        //顔画像の登録状態
        let facestatus = 0

        onValue(getUserRef, (snapshot) => {
            const users = (snapshot.val())
            if(!users || Object.keys(users).length === 0){
                //利用者一覧がない場合は、処理を終了する
                return
            }
            //利用者一覧の顔画像登録状態を更新
            Object.keys(users).forEach(key => {
                //顔画像URLが登録されているか確認(未登録の場合、初めの要素が空白""に設定されている)
                const chkFaceUrl = users[key].FaceUrl 
                                    && users[key].FaceUrl.length !== 0 
                                    && users[key].FaceUrl[0] !== ""
                //顔画像URLが登録されている場合、顔画像登録状態を1に変更する
                facestatus = chkFaceUrl ? 1: 0
                //更新用のオブジェクトを追加
                 updates[`${key}/FaceStatus2`] = {
                    ...(users[key].FaceStatus2 || {}),   // 既存のデータを保持し、なければ空のオブジェクトを作成
                    [terminalUUId]: facestatus          // 新しい要素を追加
                };
            });
        })
        await update(getUserRef, updates)
    }

    // こちらの方がベターだが、親機の登録がうまくいかないので要修正
    /* 
    const setFaceStatus = async(terminalUUId) => {
        const userPath = `CorporateId/${reactiveObj.corporateId}/User`
        const getUserRef = databaseRef(database, userPath);
        // 更新用オブジェクトの作成
        const updates = {};
        //顔画像の登録状態
        const snapshot = await get(getUserRef);
        const users = snapshot.val();
        if (!users || Object.keys(users).length === 0) {
            //利用者一覧がない場合は、処理を終了する
            return;
        }
        //利用者一覧の顔画像登録状態を更新
        Object.keys(users).forEach(key => {
            //顔画像URLが登録されているか確認(未登録の場合、初めの要素が空白""に設定されている)
            const chkFaceUrl = users[key].FaceUrl 
                && users[key].FaceUrl.length !== 0 
                && users[key].FaceUrl[0] !== "";
            //顔画像URLが登録されている場合、顔画像登録状態を1に変更する
            const facestatus = chkFaceUrl ? 1 : 0;
            //更新用のオブジェクトを追加
            updates[`${key}/FaceStatus2`] = {
                ...(users[key].FaceStatus2 || {}),  // 既存のデータを保持し、なければ空のオブジェクトを作成
                [terminalUUId]: facestatus          // 新しい要素を追加
            };
        });
        await update(getUserRef, updates)
    }
    */

    //顔画像登録状態の変更
    const changeFaceStatus = async(terminalUUId) => {
        const userPath = `CorporateId/${reactiveObj.corporateId}/User`
        const getUserRef = databaseRef(database, userPath);
        // 更新用オブジェクトの作成
        const updates = {};

        //利用者情報一覧の取得
        const snapshot = await get(getUserRef);

        if (!snapshot.exists()) {
            //利用者一覧がない場合は、処理を終了する
            return
        }

         snapshot.forEach((userSnap) => {
            //UIDの取得
            const userId = userSnap.key;
            //faceStatus・faceStatus2の取得
            const faceStatus = userSnap.child("FaceStatus").val();
            const faceStatus2 = userSnap.child("FaceStatus2").val();

            //faceStatusが存在かつ顔画像の登録状況が2(読込済) or 3(顔未検出)だったら、1(登録済)に戻す
            if (faceStatus && ((faceStatus === 2 || faceStatus === 3))){
                updates[`${userId}/FaceStatus`] = 1;
            }

            //該当端末IDのfaceStatus2が存在したら、更新する
            if (faceStatus2 && faceStatus2[terminalUUId] !== undefined) {
                const keyValue = faceStatus2[terminalUUId];
                //顔画像の登録状況が2(読込済) or 3(顔未検出)だったら、1(登録済)に戻す
                if (keyValue === 2 || keyValue === 3) {
                    updates[`${userId}/FaceStatus2/${terminalUUId}`] = 1;
                }
            }
        });

        //User情報の更新
        if (Object.keys(updates).length > 0) {
            await update(getUserRef, updates);
        }
    }

    //顔画像登録状態の削除
    const deleteFaceStatus = async (deleteTerminalId) => {
        const userPath = `CorporateId/${reactiveObj.corporateId}/User`
        const getUserRef = databaseRef(database, userPath);
        // 更新用オブジェクトの作成
        const updates = {};
        // データ取得
        const snapshot = await get(getUserRef);
        const users = snapshot.val();

        if(!users || Object.keys(users).length === 0){
            //利用者一覧がない場合は、処理を終了する
            console.log("deleteFaceStatus Not Users")
            return
        }
        Object.keys(users).forEach(userId => {
            if (users[userId].FaceStatus2) {
                deleteTerminalId.forEach(key => {
                    delete users[userId].FaceStatus2[key]; // 不要なキーを削除
                })
                updates[`${userId}/FaceStatus2`] = users[userId].FaceStatus2;
            }
        })
        await update(getUserRef, updates)
    }

    //現在作成した端末数の計測
    const countTerminal = async () => {
        //登録端末数の計測
            const TerminalCount = reactiveObj.terminalObjects.filter(element => element.TerminalType == 'parent' || element.TerminalType == 'single').length
            const CorporateInfoData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/CorporateInfo/`);
            await update(CorporateInfoData, {TerminalCount});
    }

    //削除後にページ数が減った場合の調整
    const adjustPagecount = async () => {
        //現在のページを再計算
        const maxPage = Math.ceil(reactiveObj.terminalObjects.length / perPage) ? Math.ceil(reactiveObj.terminalObjects.length / perPage) : 1
        //削除後にページ数が減った場合、現在のページ = 全体のページ数とする
        if (reactiveObj.currentPage > maxPage) {
            reactiveObj.currentPage = Number(maxPage);
            //モーダルウィンドウを再描画
            reactiveObj.renderKey++
        }
    }

    //コンポーネントがマウントされた後に実行
    onMounted(async () => {
        //企業コードを取得
        reactiveObj.corporateId = await utilFunctions.getCorporateId()
        // 端末一覧を取得
        await getTerminals()
        //アプリ設定を取得
        await getAppSetting()
    })
</script>
<template>
    <!-- コメントアウト用 -->
    <HeaderComponent></HeaderComponent>
    <NavigationBar></NavigationBar>
    <main>
        <div id="loadingDisplay" class="loading" v-show="reactiveObj.loadingFlag">
            <div class="load-text load-blink">削除中...</div>
        </div>
        <div class="terminalStatus" :key="`${reactiveObj.renderKey}-terminalStatus`">
            <div class="titleArea">
                <p class="title">端末状況</p>
                <button id="addButton" @click="showAddModal">端末追加</button>
                <AddTerminalComponent v-show="reactiveObj.addModalFlag" @executeMethod="closeAddModal"></AddTerminalComponent>
            </div>
            <div class="tableArea">
                <table class="commonTable">
                    <tbody>
                        <tr>
                            <th id="terminal" class="leftSideTh">端末名</th>
                            <th id="completelyLock">状況</th>
                            <th id="parent">親子設定</th>
                            <th id="displayLatest" class="leftSideTh">最終更新日時</th>
                            <th id="edit">編集</th>
                            <th id="delete">削除</th>
                        </tr>
                        <tr v-for="(data, key) in getItems" :key="key">
                            <td class="leftSideTd" id="terminalname">{{ data.TerminalName }}({{ data.Location }})</td>
                            <td
                                class="completelyLock"
                                :class="{ disabled: !data.Connection }"
                                @click="data.Connection ? showStatusModal(data, (reactiveObj.currentPage - 1) * perPage + key) : null"
                            >
                                {{
                                    !data.Connection ? "停止中" :
                                    data.CompletelyLock ?  "単体施錠" :
                                        reactiveObj.NightFlag ? "夜間施錠" : "稼働中"
                                }}
                            </td>
                            <td>{{ data.TerminalType == 'parent'? '親機': data.TerminalType == 'child'? '子機' : '単独' }}</td>
                            <td class="leftSideTd">{{ data.DisplayLatestUpdated  }}</td>
                            <td><button type="button" class="editButton" @click="showEditModal(data, (reactiveObj.currentPage-1)*perPage+key)"><img src="../../assets/pencil.png" id="pencilIcon"></button></td>
                            <td><button type="button" class="deleteButton" @click="showDeleteModal(data, (reactiveObj.currentPage-1)*perPage+key)"><img src="../../assets/delete.png" id="deletelIcon"></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <EditTerminalComponent
                :key="reactiveObj.renderKey"
                :terminalObject="reactiveObj.terminalObject"
                v-show="reactiveObj.editModalFlag"
                @executeMethod="closeEditModal">
            </EditTerminalComponent>
            <LockStatusComponent
                :key="reactiveObj.renderKey"
                :terminalObject="reactiveObj.terminalObject"
                :NightFlag="reactiveObj.NightFlag"
                v-show="reactiveObj.lockModalFlag"
                @executeMethod="closeStatusModal">
            </LockStatusComponent>
            <DefaultModalComponent
                :key="reactiveObj.renderKey"
                :modalMessage="reactiveObj.modalMessage"
                :modalRedMessage="reactiveObj.modalRedMessage"
                :otherObject="reactiveObj.otherObject"
                v-show="reactiveObj.deleteModalFlag"
                @executeMethod="closeDeleteModal">
            </DefaultModalComponent>
        </div>
        <div class="paginationArea">
            <PaginateComponent
                :page-count="getPageCount"
                :click-handler="clickCallback"
                :page-range="5"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :force-page="reactiveObj.currentPage">
            </PaginateComponent>
        </div>
    </main>
</template>

<style scoped>
    .terminalStatus{
        padding: 0 5% 0 25%;
        background-color: #e7e6e6;
    }
    #addButton {
        position: relative;
        display: flex;
        margin-left: auto;
        top: -40px;
        border: solid 3px #00AEEB;
        background: #00AEEB;
        color: #FFFFFF;
    }
    .commonTable #terminal{
        width: 45%;
    }
    .commonTable #completelyLock{
        width: 10%;
    }
    .commonTable #edit{
        width: 10%;
    }
    .commonTable #parent{
        width: 10%;
    }
    .commonTable #displayLatest{
        width: 15%;
        white-space: nowrap
    }
    #naviTerminalStatusView {
        background-color: #32a4ea;
        color: #F5F5F5;
    }
    .completelyLock {
        cursor: pointer;
        color: #0d6efd;
        text-decoration: underline;
        border-color: #4a4a4a;
        white-space: nowrap;
    }
    .disabled {
        pointer-events: none;
        cursor: default;
        color: #3f3f3f;
        text-decoration: none;
    }
    @media (max-width: 1150px) {
        .terminalStatus{
            padding: 0 5% 0 5%;
        }
        .tableArea {
            overflow-x: scroll;
        }
        .commonTable th {
            padding: 0 10px;
        }
        #terminalname{
            white-space: nowrap;
            padding: 0 10px;
        }
    }
</style>
